import "react-toastify/dist/ReactToastify.css";
import "./app.css";
import "./assets/styles/style.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/fonts/flaticon.css";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import Body from "./shared-components/body/body";
import { getThemeFromLocalStorage } from "./helpers/localstorage-helper";
import { useEffect } from "react";
import { useIntl } from "react-intl";


const App = () => {
  const intl = useIntl();
  
  useEffect(() => {
    // Set the lang attribute based on current locale
    document.documentElement.setAttribute("translate", "no");
    document.documentElement.lang = intl.locale === 'jp' ? 'ja' : 'en'; // 'en' or 'ja'
  }, [intl.locale]);

  useEffect(() => {
    const savedTheme = localStorage.getItem('lizera_theme') || '0';
    const savedLang = localStorage.getItem('lizera_language') || 'jp';
    const body = document.body;
    body.className = "";
    body.classList.add(`theme${savedTheme}`);
    body.classList.add(`lang-${savedLang}`);
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (document.body.style.overflow === "hidden") {
        // Only reset if no modal is open
        const hasOpenModal = document.querySelector(".modal-open, .ant-modal-root, .MuiModal-root");
        if (!hasOpenModal) {
          document.body.style.overflow = "";
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="App" data-testid="AppDiv">
      <Body />
      <Toaster position="top-center" reverseOrder={true} >
        {(t) => (
          <div className="Custometoast">
          <ToastBar toast={t} >
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button onClick={() => toast.dismiss(t.id)} >
                    <i className="close">&times;</i>
                  </button>
                )}
              </>
            )}
          </ToastBar>
          </div>
        )}
      </Toaster>
    </div>
  );
};


export default App;
